import { Divider } from '@mui/material';
import { IAddresses, IPhones } from 'API/personalDetails';
import { AccordionUserDetails } from '../AccordionDetails';
import { AddressInformation } from './AddressInformation';
import { BankInformation } from './BankInformation';
import { ContactInformation } from './ContactInformation';
import { UserInformation } from './UserInformation';

interface IGeneralAccordion {
  title: string;
  userInfo?: {
    fullName: string;
    id: string;
    caseNumber: string;
    familyStatus: string;
  };
  userContact?: {
    phones: IPhones[];
  };
  userAddress?: IAddresses[];
  userBank?: {
    bankName: string;
    branchCode: string;
    branchName: string;
    accountNum: string;
  };
  isRecognized?: boolean;
  haveFamilyMembers?: boolean;
}

export const GeneralAccordion = (props: IGeneralAccordion) => {
  return (
    <AccordionUserDetails
      title={props.title}
      isOpen={props.userInfo || props.userContact ? true : false}
    >
      <Divider
        aria-hidden={'true'}
        orientation={'horizontal'}
        sx={{ borderColor: 'primary.shade_100', marginBottom: '16px' }}
      />
      {props.userInfo && (
        <UserInformation
          userInfo={props.userInfo}
          isRecognized={!!props.isRecognized}
          haveFamilyMembers={props.haveFamilyMembers || false}
        />
      )}

      {props.userContact && (
        <ContactInformation phones={props.userContact?.phones} />
      )}
      {props.userAddress && (
        <AddressInformation addresses={props.userAddress} />
      )}
      {props.userBank && <BankInformation bankInfo={props.userBank} />}
    </AccordionUserDetails>
  );
};
